import useInView from '../../../hooks/useInView';

const stats = [
  { value: '2,400+', label: 'Projects Completed', icon: 'ri-home-gear-line' },
  { value: '4.9★', label: 'Average Customer Rating', icon: 'ri-star-fill' },
  { value: '10-Year', label: 'Parts & Labor Warranty', icon: 'ri-shield-check-line' },
  { value: '24/7', label: 'Emergency Service', icon: 'ri-customer-service-2-line' },
];

const StatsStrip = () => {
  const { ref, inView } = useInView({ threshold: 0.2 });

  return (
    <section className="bg-[#0C2340] py-12" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className="text-center transition-all duration-700"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(24px)',
                transitionDelay: `${i * 100}ms`,
              }}
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-2xl text-[#C41E3A]`} />
              </div>
              <div className="text-3xl lg:text-4xl font-bold text-white mb-1 tracking-tight">{stat.value}</div>
              <div className="text-sm text-white/60 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsStrip;
